import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import { Field, ErrorMessage } from "formik"
import { PaginationDownSVG, PaginationUpSVG } from "../icons"
import { getFileRequestByPage } from "../../actions/documentModalActions"

import { useHistory } from "react-router-dom"
import _ from "lodash"
import { updateViewerPageNumber } from "../../actions/viewerActions"

const useStyles = makeStyles((theme) => ({
	pagination: {
		flex: 5,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "16px 23px",
		borderRight: `solid 1px ${theme.palette.grey.D400}`,
		"& .MuiInputBase-input": {
			padding: "5px 10px",
			marginRight: "10px",
			border: `solid 1px ${theme.palette.grey.D400}`,
		},
	},
}))

const ViewerPagination = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [pageNumber, setPageNumber] = useState(1)
	const { documentDetails, pageNumberForCurrentDocument } = useSelector((state) => state.documentModal)
	const { currentPageNumber } = useSelector((state) => state.viewerData)

	const nextClick = () => {
		if (currentPageNumber < documentDetails?.metadata?.total_page_number) {
			const id = documentDetails?.file_id
			const page = Number(currentPageNumber) + 1
			const reviewId = props.retainedFilterJobData?.additional_params?.review_id
			dispatch(getFileRequestByPage({ id, page, reviewId }))
			dispatch(updateViewerPageNumber(page))
			const viewerContainer = document.getElementById("viewer-container")
			viewerContainer?.scrollIntoView(true)
		}
	}

	const previousClick = () => {
		if (currentPageNumber > 1) {
			const id = documentDetails?.file_id
			const page = Number(currentPageNumber) - 1
			const reviewId = props.retainedFilterJobData?.additional_params?.review_id
			dispatch(getFileRequestByPage({ id, page, reviewId }))
			dispatch(updateViewerPageNumber(page))
			const viewerContainer = document.getElementById("viewer-container")
			viewerContainer?.scrollIntoView(true)
		}
	}

	const numericValueOnClick = (ev) => {
		if (ev.key === "Enter") {
			if (currentPageNumber != 0) {
				if (currentPageNumber <= documentDetails?.metadata?.total_page_number) {
					const id = documentDetails?.file_id
					const page = Number(currentPageNumber)
					const reviewId = props.retainedFilterJobData?.additional_params?.review_id
					dispatch(getFileRequestByPage({ id, page, reviewId }))
				} else {
					dispatch(updateViewerPageNumber(1))
				}
				const viewerContainer = document.getElementById("viewer-container")
				viewerContainer?.scrollIntoView(true)
			}
		}
		ev.preventDefault()
	}

	const numericValueOnChange = (e) => {
		const value = e?.target?.value
		const re = /^[0-9\b]+$/
		if (value === "" || (re.test(value) && value <= documentDetails?.metadata?.total_page_number)) {
			dispatch(updateViewerPageNumber(e?.target?.value))
			//setPageNumber(e?.target?.value)
		}
	}

	return (
		<>
			<Box className={classes.pagination}>
				<Box onClick={previousClick} style={{ display: "flex", cursor: "pointer", opacity: currentPageNumber > 1 ? 1 : 0.5 }}>
					<PaginationUpSVG />
				</Box>
				<Box
					onClick={nextClick}
					style={{
						padding: "0px 10px",
						display: "flex",
						cursor: "pointer",
						opacity: currentPageNumber < documentDetails?.metadata?.total_page_number ? 1 : 0.5,
					}}
				>
					<PaginationDownSVG />
				</Box>
				<Box style={{ display: "flex", alignItems: "center" }}>
					<TextField
						type="text"
						variant="outlined"
						value={currentPageNumber}
						onKeyUp={numericValueOnClick}
						onChange={numericValueOnChange}
						style={{ width: "60px", padding: 0, margin: 0 }}
					/>
					/ <Typography style={{ paddingLeft: "10px" }}>{documentDetails?.metadata?.total_page_number || 1}</Typography>
				</Box>
			</Box>
		</>
	)
}

export default ViewerPagination
